import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m8.433 16.704-6.695-6.645C.865 9.193.384 8.04.384 6.814S.865 4.436 1.738 3.57a4.645 4.645 0 0 1 6.527 0l.167.176.167-.175a4.65 4.65 0 0 1 6.529-.001 4.54 4.54 0 0 1 1.354 3.244c0 1.226-.48 2.378-1.354 3.245z" }, null, -1)
  ]))]))
}
export default { render: render }